import { Input } from 'antd';
import classNames from 'classnames';
import useOnClickOutside from 'hooks/useOnClickOutside';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { ChangeEvent, FC, useMemo, useRef, useState } from 'react';
import { ColorResult, SketchPicker, SliderPicker } from 'react-color';
import { useDispatch } from 'react-redux';
import CollectionService from 'services/CollectionService';
import { setIsColorPickerOpen } from 'store/reducers/common.slice';
import {
  changeElemStyles,
  changeElemsStylesByIds,
} from 'store/reducers/elems.slice';

import { MIXED_COLOR_VALUE } from './ElemColorSettings.constants';
import { getInitialColor } from './ElemColorSettings.helpers';
import styles from './ElemColorSettings.module.scss';

interface IProps {
  defaultColor: string;
}

const ElemColorSettings: FC<IProps> = ({ defaultColor }) => {
  const selectedElemsIds = useTypedSelector(
    (state) => state.elems.selectedElemsIds,
  );
  const elems = useTypedSelector((state) => state.elems.elems);
  const isColorPickerOpen = useTypedSelector(
    (state) => state.common.isColorPickerOpen,
  );

  const dispatch = useDispatch();

  // const [isPickerOpen, setIsPickerOpen] = useState(false);

  const pickerRef = useRef(null);

  const handleOpenPicker = (): void => {
    console.log('isColorPickerOpen', isColorPickerOpen);
    dispatch(setIsColorPickerOpen(!isColorPickerOpen));
  };

  // useOnClickOutside(pickerRef, () => setIsPickerOpen(false));
  useOnClickOutside(pickerRef, handleOpenPicker);

  const color = useMemo(() => {
    const selectedElems = CollectionService.getAllByIds(
      elems,
      selectedElemsIds,
    );
    const initialColor = getInitialColor(selectedElems);
    return initialColor;
  }, [elems, selectedElemsIds]);

  const colorChangeHandler = (newColor: ColorResult): void => {
    // if (color === 'mixed') return;

    dispatch(
      changeElemsStylesByIds({
        ids: selectedElemsIds,
        styles: { background: newColor.hex },
      }),
    );

    // handleOpenPicker();
  };

  const changeColorInputHandler = (e: ChangeEvent<HTMLInputElement>): void => {
    selectedElemsIds.forEach((id) => {
      dispatch(
        changeElemStyles({
          id,
          styles: { background: e.target.value },
        }),
      );
    });
  };

  return (
    <div className={styles['colors']}>
      <div className={styles['color-container']}>
        <div
          className={styles['color-circle']}
          style={{ background: color }}
          // onClick={() => setIsPickerOpen((prev) => !prev)}
          onClick={handleOpenPicker}
        />

        <Input
          className={styles['color-input']}
          value={color}
          onChange={changeColorInputHandler}
        />
      </div>

      {color !== MIXED_COLOR_VALUE && (
        <SliderPicker
          className={styles['slider-picker']}
          color={color}
          onChange={colorChangeHandler}
        />
      )}

      {isColorPickerOpen && (
        <div
          ref={pickerRef}
          className={classNames(
            styles['picker-wrapper'],
            'test-picker-wrapper',
          )}
        >
          <SketchPicker
            width={'300px'}
            className={styles['sketch-picker']}
            // disableAlpha={true}
            color={color}
            onChange={colorChangeHandler}
          />
        </div>
      )}
    </div>
  );
};

export default ElemColorSettings;
